import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.manual.list');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-gsdcadmin-manual-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.manual.list/view.scss */
:host {
  --am-bg:#fff;
  --am-surface:#f1f4f8;
  --am-line:#dce5f0;
  --am-title:#203750;
  --am-text:#344860;
  --am-muted:#617186;
  --am-accent:#175d9c;
  --am-tint:#eaf2fc;
}

:host-context(html.dark) {
  --am-bg:#172537;
  --am-surface:#22334a;
  --am-line:#34455b;
  --am-title:#edf3fb;
  --am-text:#d1ddeb;
  --am-muted:#a8b8cd;
  --am-accent:#8bc8fa;
  --am-tint:#203c59;
}

:host {
  display: block;
  width: 100%;
  height: calc(100vh - 140px);
  min-height: 620px;
}

.admin-docs {
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr) 230px;
  height: 100%;
  min-height: 0;
  border: 1px solid var(--am-line);
  background: var(--am-bg);
}

.admin-sidebar,
.admin-main,
.admin-outline {
  min-height: 0;
  overflow: hidden;
}

.admin-sidebar {
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--am-line);
  background: var(--am-surface);
}

.admin-sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 14px;
  border-bottom: 1px solid var(--am-line);
  background: var(--am-bg);
}

.admin-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--am-title);
  font-size: 14px;
  font-weight: 700;
}

.admin-title i {
  color: #2563eb;
}

.admin-create-actions,
.toolbar-actions,
.tree-actions,
.tree-inline-controls {
  display: flex;
  align-items: center;
}

.admin-create-actions {
  gap: 4px;
}

.admin-search {
  position: relative;
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid var(--am-line);
  background: var(--am-bg);
}

.admin-search > i {
  position: absolute;
  left: 20px;
  color: var(--am-muted);
  font-size: 12px;
  pointer-events: none;
}

.admin-search-input {
  width: 100%;
  height: 30px;
  padding: 0 32px 0 30px;
  border: 1px solid var(--am-line);
  border-radius: 6px;
  background: var(--am-surface);
  color: var(--am-title);
  font-size: 13px;
  outline: none;
}

.admin-search-input:focus {
  border-color: #93c5fd;
  background: var(--am-bg);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.admin-search-clear {
  position: absolute;
  right: 16px;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--am-muted);
  cursor: pointer;
}

.admin-search-clear:hover {
  background: #e2e8f0;
  color: var(--am-text);
}

.icon-button,
.soft-button,
.primary-button,
.tree-row,
.tree-action,
.tree-confirm,
.tree-cancel,
.title-action,
.outline-link {
  cursor: pointer;
}

.icon-button,
.tree-action,
.tree-confirm,
.tree-cancel,
.title-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--am-muted);
}

.icon-button {
  width: 30px;
  height: 30px;
}

.icon-button:hover,
.tree-action:hover,
.title-action:hover {
  border-color: #bfdbfe;
  background: var(--am-tint);
  color: var(--am-accent);
}

.soft-button,
.primary-button {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 13px;
  border: 1px solid var(--am-line);
  background: var(--am-bg);
  color: var(--am-text);
}

.soft-button:hover,
.soft-button.is-active {
  border-color: #93c5fd;
  background: var(--am-tint);
  color: var(--am-accent);
}

.primary-button {
  border-color: #2563eb;
  background: #2563eb;
  color: var(--am-bg);
}

.primary-button:hover {
  background: var(--am-accent);
}

.primary-button:disabled,
.tree-confirm:disabled,
.tree-cancel:disabled {
  opacity: 0.6;
  cursor: default;
}

.admin-tree {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 8px 0;
}

.tree-row {
  width: 100%;
  min-height: 32px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: #475569;
  font-size: 13px;
  text-align: left;
}

.tree-row:hover {
  background: #eef2ff;
  color: var(--am-accent);
}

.tree-row.is-active {
  background: #dbeafe;
  color: var(--am-accent);
  font-weight: 600;
}

.tree-row.is-folder-active:not(.is-active) {
  color: var(--am-accent);
}

.tree-row.is-file {
  cursor: grab;
}

.tree-row.is-file.is-dragging {
  opacity: 0.45;
}

.tree-row.is-drop-target {
  outline: 1px dashed #93c5fd;
  outline-offset: -3px;
}

.tree-row.is-drag-over {
  background: #dcfce7;
  color: #166534;
  box-shadow: inset 3px 0 0 #22c55e;
}

.tree-row.is-drag-over .tree-folder {
  color: #16a34a;
}

.tree-row .tree-label {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tree-match {
  padding: 0 2px;
  border-radius: 3px;
  background: #fde68a;
  color: #78350f;
  font-weight: 700;
}

:host ::ng-deep .markdown-body .manual-content-match {
  padding: 0 2px;
  border-radius: 3px;
  background: #fef08a;
  color: #713f12;
  font-weight: 750;
  box-shadow: 0 0 0 1px rgba(202, 138, 4, 0.22);
}

.root-drop-zone {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 10px 8px;
  padding: 9px 10px;
  border: 1px dashed #93c5fd;
  border-radius: 7px;
  background: var(--am-tint);
  color: var(--am-accent);
  font-size: 12px;
  font-weight: 700;
}

.root-drop-zone.is-drag-over {
  border-color: #22c55e;
  background: #dcfce7;
  color: #166534;
}

.root-drop-zone.is-disabled {
  border-color: var(--am-line);
  background: var(--am-surface);
  color: var(--am-muted);
}

.tree-actions {
  flex: 0 0 auto;
  gap: 2px;
  padding-right: 6px;
  opacity: 0;
  transition: opacity 120ms ease;
}

.tree-row:hover .tree-actions,
.tree-row.is-active .tree-actions,
.tree-row.is-folder-active .tree-actions {
  opacity: 1;
}

.tree-action {
  width: 24px;
  height: 24px;
  font-size: 11px;
}

.tree-caret {
  width: 10px;
  flex: 0 0 10px;
  color: var(--am-muted);
  font-size: 10px;
  transition: transform 120ms ease;
}

.tree-caret.is-open {
  transform: rotate(90deg);
}

.tree-folder {
  color: #d97706;
  font-size: 12px;
}

.tree-file {
  color: var(--am-muted);
  font-size: 12px;
}

.tree-inline-row {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  background: var(--am-bg);
}

.tree-inline-row > i {
  width: 16px;
  flex: 0 0 16px;
  margin-top: 8px;
  color: #2563eb;
  font-size: 12px;
  text-align: center;
}

.tree-inline-body {
  flex: 1;
  min-width: 0;
}

.tree-inline-controls {
  gap: 4px;
}

.tree-inline-input {
  flex: 1;
  min-width: 0;
  height: 30px;
  padding: 0 9px;
  border: 1px solid #93c5fd;
  border-radius: 6px;
  background: var(--am-bg);
  color: var(--am-title);
  font-size: 13px;
  outline: none;
}

.tree-inline-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.tree-confirm,
.tree-cancel {
  width: 22px;
  height: 26px;
  flex: 0 0 22px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  font-size: 12px;
}

.tree-confirm {
  color: var(--am-accent);
}

.tree-confirm:hover {
  background: var(--am-tint);
}

.tree-cancel {
  color: var(--am-muted);
}

.tree-cancel:hover {
  color: var(--am-text);
}

.danger-action:hover {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626;
}

.tree-inline-error {
  margin-top: 5px;
  color: #dc2626;
  font-size: 12px;
  line-height: 1.35;
}

.admin-main {
  display: flex;
  flex-direction: column;
  position: relative;
  background: var(--am-bg);
}

.admin-message {
  margin: 8px 10px 0;
  padding: 8px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  background: var(--am-tint);
  color: var(--am-accent);
  font-size: 12px;
  line-height: 1.35;
}

.admin-state {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--am-muted);
  font-size: 14px;
  text-align: center;
}

.admin-state i {
  margin-bottom: 12px;
  color: var(--am-line);
  font-size: 34px;
}

.admin-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 0 14px;
  border-bottom: 1px solid var(--am-line);
  background: var(--am-bg);
}

.doc-label {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--am-title);
  font-size: 14px;
  font-weight: 700;
}

.doc-label span {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.doc-label i {
  color: var(--am-muted);
}

.rename-label {
  flex: 1;
  max-width: 520px;
}

.title-action {
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  font-size: 11px;
}

.title-input {
  height: 32px;
}

.toolbar-actions {
  justify-content: flex-end;
  gap: 8px;
}

.editor-area {
  flex: 1;
  min-height: 0;
}

.editor-area textarea {
  width: 100%;
  height: 100%;
  min-height: 520px;
  padding: 20px;
  border: 0;
  outline: none;
  resize: none;
  color: var(--am-title);
  background: var(--am-bg);
  font-family: Consolas, Monaco, monospace;
  font-size: 14px;
  line-height: 1.6;
}

.preview-area {
  flex: 1;
  min-height: 0;
  overflow: auto;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 34px 40px 72px;
}

.preview-kicker {
  margin-bottom: 8px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.preview-title {
  margin: 0 0 26px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--am-line);
  color: var(--am-title);
  font-size: 28px;
  line-height: 1.25;
  font-weight: 750;
}

.admin-outline {
  overflow: auto;
  padding: 24px 16px;
  border-left: 1px solid var(--am-line);
  background: var(--am-bg);
}

.outline-title {
  margin-bottom: 10px;
  color: var(--am-title);
  font-size: 13px;
  font-weight: 700;
}

.outline-title.second {
  margin-top: 22px;
}

.outline-meta {
  padding: 10px;
  border-radius: 8px;
  background: var(--am-surface);
  color: var(--am-muted);
  font-size: 12px;
  word-break: break-all;
}

.outline-meta strong {
  display: block;
  margin-top: 4px;
  color: var(--am-title);
  font-weight: 600;
}

.outline-empty {
  color: var(--am-muted);
  font-size: 12px;
}

.outline-link {
  width: 100%;
  display: block;
  padding: 5px 0;
  border: 0;
  background: transparent;
  color: var(--am-muted);
  font-size: 12px;
  line-height: 1.35;
  text-align: left;
}

.outline-link:hover {
  color: var(--am-accent);
}

.outline-link.is-active {
  color: var(--am-accent);
  font-weight: 700;
}

.outline-link.is-sub {
  padding-left: 12px;
}

.outline-link.is-deep {
  padding-left: 22px;
}

.admin-empty {
  padding: 24px 14px;
  color: var(--am-muted);
  font-size: 13px;
}

.markdown-body {
  color: var(--am-text);
  font-size: 15px;
  line-height: 1.72;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3 {
  color: var(--am-title);
  font-weight: 700;
  line-height: 1.3;
}

.markdown-body h1 {
  font-size: 26px;
  margin: 30px 0 14px;
}

.markdown-body h2 {
  font-size: 22px;
  margin: 28px 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--am-line);
}

.markdown-body h3 {
  font-size: 18px;
  margin: 22px 0 10px;
}

.markdown-body p {
  margin: 10px 0;
}

.markdown-body ul,
.markdown-body ol {
  margin: 10px 0;
  padding-left: 24px;
}

.markdown-body li {
  margin: 4px 0;
}

.markdown-body a {
  color: #2563eb;
  text-decoration: none;
}

.markdown-body a:hover {
  text-decoration: underline;
}

.markdown-body code {
  padding: 2px 5px;
  border-radius: 4px;
  background: var(--am-surface);
  color: var(--am-accent);
  font-size: 13px;
}

.markdown-body pre {
  margin: 16px 0;
  padding: 16px;
  overflow: auto;
  border-radius: 6px;
  background: #0f172a;
  color: #e2e8f0;
}

.markdown-body pre code {
  padding: 0;
  background: transparent;
  color: inherit;
}

.markdown-body table {
  width: 100%;
  margin: 16px 0;
  border-collapse: collapse;
}

.markdown-body th,
.markdown-body td {
  padding: 8px 10px;
  border: 1px solid var(--am-line);
}

.markdown-body th {
  background: var(--am-surface);
  font-weight: 700;
}

.markdown-body blockquote {
  margin: 16px 0;
  padding: 10px 16px;
  border-left: 4px solid #2563eb;
  background: var(--am-tint);
  color: var(--am-accent);
}

.markdown-body img {
  max-width: 100%;
  border-radius: 6px;
}

@media (max-width: 1180px) {
  :host {
    height: auto;
    min-height: 0;
  }
  .admin-docs {
    display: block;
    min-height: 640px;
  }
  .admin-sidebar {
    max-height: 420px;
    border-right: 0;
    border-bottom: 1px solid var(--am-line);
  }
  .admin-main {
    min-height: 620px;
  }
  .admin-toolbar {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding: 12px 14px;
  }
  .toolbar-actions {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .rename-label {
    width: 100%;
    max-width: none;
  }
  .admin-outline {
    display: none;
  }
  .preview-area {
    padding: 28px 20px 56px;
  }
}
:host {
  height: calc(100dvh - 140px);
  min-height: 560px;
}

.admin-docs {
  grid-template-columns: 260px minmax(0, 1fr) 195px;
  gap: 16px;
  border: 0;
  background: transparent;
}

.admin-sidebar, .admin-main, .admin-outline {
  min-width: 0;
  border: 0;
  border-radius: 12px;
  background: var(--am-bg);
  box-shadow: 0 1px 3px rgba(25, 46, 73, 0.07);
}

.admin-sidebar-head {
  height: 60px;
  flex-shrink: 0;
  border: 0;
  padding: 0 14px;
}

.admin-title {
  font-weight: 600;
  color: var(--am-title);
}

.admin-search {
  border: 0;
  padding: 0 12px 8px;
  height: 48px;
  flex-shrink: 0;
}

.admin-search-input {
  height: 36px;
  border: 0;
}

.admin-toolbar {
  min-height: 64px;
  height: auto;
  border: 0;
  gap: 10px;
  padding: 14px 20px;
  flex-wrap: wrap;
}

.doc-label {
  min-width: 0;
  font-weight: 600;
}

.toolbar-actions {
  flex-wrap: wrap;
  gap: 6px;
}

.primary-button {
  background: #175d9c;
  border-color: #175d9c;
  color: #fff;
}

.primary-button:hover {
  background: #124c81;
}

.tree-row {
  min-height: 38px;
  border-radius: 7px;
  margin: 2px 8px;
  font-size: 13px;
}

.tree-actions {
  opacity: 1;
}

.tree-action {
  width: 26px;
  height: 28px;
}

.tree-row:focus-within .tree-actions {
  opacity: 1;
}

button:focus-visible, input:focus-visible, textarea:focus-visible {
  outline: 3px solid var(--am-accent);
  outline-offset: 2px;
}

.editor-area {
  padding: 0 20px 20px;
}

.editor-area textarea {
  border: 0;
  border-radius: 8px;
  padding: 18px;
  color: var(--am-text);
  background: var(--am-surface);
  font-size: 14px;
  line-height: 1.8;
}

.preview-area {
  padding: 22px 32px 48px;
}

.preview-title {
  font-size: 27px;
  line-height: 1.45;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.markdown-body {
  font-size: 15px;
  line-height: 1.85;
}

.markdown-body h2 {
  border: 0;
  padding-bottom: 0;
}

.outline-link {
  border-radius: 6px;
  padding: 8px;
  margin: 2px 0;
  line-height: 1.55;
}

.outline-link.is-active {
  background: var(--am-tint);
  color: var(--am-accent);
}

.outline-meta strong {
  font-weight: 400;
  overflow-wrap: anywhere;
}

@media (max-width: 1280px) {
  .admin-docs {
    grid-template-columns: 230px minmax(0, 1fr);
  }
  .admin-outline {
    display: none;
  }
}
@media (max-width: 1180px) {
  :host {
    height: auto;
    min-height: 0;
  }
  .admin-docs {
    display: grid;
    grid-template-columns: 230px minmax(0, 1fr);
    min-height: 600px;
  }
  .admin-sidebar {
    max-height: 750px;
  }
  .admin-main {
    min-height: 600px;
  }
}
@media (max-width: 767px) {
  .admin-docs {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .admin-sidebar {
    max-height: 320px;
  }
  .admin-main {
    min-height: 500px;
  }
  .preview-area {
    padding: 20px;
  }
  .preview-title {
    font-size: 23px;
  }
  .admin-toolbar {
    padding: 14px;
  }
  .editor-area {
    padding: 0 14px 14px;
  }
  .admin-tree {
    min-height: 100px;
  }
  .tree-actions {
    flex-wrap: wrap;
  }
  .editor-area textarea {
    min-height: 360px;
    font-size: 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .tree-actions, .tree-caret {
    transition: none;
  }
}
.preview-title {
  padding-bottom: 0;
  border-bottom: 0;
}

:host ::ng-deep .preview-area .markdown-body {
  color: var(--am-text);
  font-size: 15px;
  line-height: 1.85;
  background: transparent;
}

:host ::ng-deep .preview-area .markdown-body :is(h1, h2, h3) {
  color: var(--am-title);
  border-bottom: 0 !important;
  padding-bottom: 0 !important;
  font-weight: 600;
}

:host ::ng-deep .preview-area .markdown-body h1 {
  font-size: 27px;
}

:host ::ng-deep .preview-area .markdown-body h2 {
  font-size: 22px;
}

:host ::ng-deep .preview-area .markdown-body h3 {
  font-size: 18px;
}

:host ::ng-deep .preview-area .markdown-body pre {
  background: #0f172a;
  color: #e2e8f0;
}

:host ::ng-deep .preview-area .markdown-body a {
  color: var(--am-accent);
}

:host ::ng-deep .preview-area .markdown-body blockquote {
  background: var(--am-tint);
  color: var(--am-text);
}`],
})
export class PortalGsdcadminManualListComponent implements OnInit {
    @ViewChild('markdownBody') markdownBody: ElementRef;

    constructor(@Inject( Service) public service: Service) {}

    public docs: any[] = [];
    public filteredDocs: any[] = [];
    public treeSearch: string = '';
    public selectedDoc: any = null;
    public selectedPath: string = '';
    public selectedTitle: string = '';
    public docContent: string = '';
    public docMode: string = 'markdown';
    public htmlContent: string = '';
    public headings: any[] = [];
    public expanded: any = {};
    public activeFolderPath: string = '';
    public loading: boolean = false;
    public saving: boolean = false;
    public mode: string = 'preview';
    public message: string = '';

    public inlineCreateType: string = '';
    public inlineCreateParent: string = '';
    public inlineCreateName: string = '';
    public inlineRenamePath: string = '';
    public inlineRenameName: string = '';
    public inlineRenameOrigin: string = '';
    public inlineError: string = '';
    public creating: boolean = false;
    public renaming: boolean = false;
    public deleting: boolean = false;
    public moving: boolean = false;
    public draggingPath: string = '';
    public dragOverPath: string = '';
    public rootDropPath: string = '__manual_root__';
    public activeHeadingId: string = '';

    private converter: any;
    private communityName: string = '';
    private scopePrefix: string = '';
    private inlineErrorTimer: any = null;
    private messageTimer: any = null;

    public async ngOnInit() {
        await this.service.init();
        this.converter = new showdown.Converter({
            tables: true,
            ghCodeBlocks: true,
            tasklists: true,
            strikethrough: true,
            simplifiedAutoLink: true,
            literalMidWordUnderscores: true
        });
        await this.loadCommunityScope();
        await this.loadTree();
        await this.service.render();
    }

    public async loadTree() {
        const previousPath = this.selectedPath;
        const res = await wiz.call('tree');
        if (res.code !== 200) {
            await this.showMessage('문서 목록을 불러올 수 없습니다.');
            return;
        }

        this.docs = this.applyCommunityScope(res.data || []);
        this.applyTreeFilter();

        if (previousPath) {
            const current = this.findByPath(this.docs, previousPath);
            if (current && current.type === 'file') {
                this.selectedDoc = current;
                this.selectedPath = current.path;
                this.selectedTitle = current.title;
                this.activeFolderPath = this.parentPath(current.path);
                this.expandParents(current.path);
            } else if (!current) {
                this.selectedDoc = null;
                this.selectedPath = '';
                this.selectedTitle = '';
            }
        }

        if (!this.selectedPath) {
            const first = this.findFirstFile(this.docs);
            if (first) {
                this.expandParents(first.path);
                await this.selectDoc(first);
            }
        }
        await this.service.render();
    }

    public async updateTreeSearch() {
        this.applyTreeFilter();
        if (this.docContent) this.renderContent(this.docContent, this.docMode);
        await this.service.render();
        this.scheduleContentHighlight();
    }

    public async clearTreeSearch() {
        this.treeSearch = '';
        this.applyTreeFilter();
        if (this.docContent) this.renderContent(this.docContent, this.docMode);
        await this.service.render();
        this.scheduleContentHighlight();
    }

    public async startCreateFromToolbar(type: string, event?: Event) {
        await this.startCreate(type, '', event);
    }

    public async startCreate(type: string, parent: string = '', event?: Event) {
        this.stopEvent(event);
        this.cancelRename(false);
        this.inlineCreateType = type;
        this.inlineCreateParent = this.normalizePath(parent);
        this.inlineCreateName = type === 'folder' ? '새 폴더' : '새 문서.md';
        this.inlineError = '';
        this.activeFolderPath = this.inlineCreateParent;
        if (this.inlineCreateParent) this.expanded[this.inlineCreateParent] = true;
        await this.service.render();
        this.focusInlineInput();
    }

    public cancelCreate(render: boolean = true) {
        this.inlineCreateType = '';
        this.inlineCreateParent = '';
        this.inlineCreateName = '';
        this.inlineError = '';
        if (render) this.service.render();
    }

    public async confirmCreate() {
        if (this.creating || !this.inlineCreateType) return;
        let name = (this.inlineCreateName || '').trim();
        if (!name) {
            await this.showInlineError('이름을 입력하세요.');
            return;
        }

        if (this.inlineCreateType === 'file' && name.indexOf('.') < 0) {
            name = name + '.md';
        }

        this.creating = true;
        this.inlineError = '';
        await this.service.render();

        const params = { parent: this.scopedPath(this.inlineCreateParent || ''), name: name };
        const res = this.inlineCreateType === 'folder'
            ? await wiz.call('create_folder', params)
            : await wiz.call('create_file', params);

        this.creating = false;

        if (res.code !== 200) {
            await this.showInlineError(res.data?.message || '생성에 실패했습니다.');
            return;
        }

        const created = this.toViewItem(res.data);
        const createdType = created.type;
        this.cancelCreate(false);
        this.expandParents(created.path);
        if (created.type === 'folder') {
            this.expanded[created.path] = true;
            this.activeFolderPath = created.path;
        }
        await this.loadTree();

        if (created.type === 'file') {
            await this.selectDoc(created);
            this.mode = 'edit';
        }

        await this.showMessage(createdType === 'folder' ? '폴더를 만들었습니다.' : '문서를 만들었습니다.');
    }

    public async startRename(item: any, event?: Event, origin: string = 'tree') {
        this.stopEvent(event);
        if (!item) return;
        this.cancelCreate(false);
        this.inlineRenamePath = item.path;
        this.inlineRenameName = item.title;
        this.inlineRenameOrigin = origin;
        this.inlineError = '';
        await this.service.render();
        this.focusInlineInput();
    }

    public cancelRename(render: boolean = true) {
        this.inlineRenamePath = '';
        this.inlineRenameName = '';
        this.inlineRenameOrigin = '';
        this.inlineError = '';
        if (render) this.service.render();
    }

    public async confirmRename() {
        if (this.renaming || !this.inlineRenamePath) return;
        const name = (this.inlineRenameName || '').trim();
        if (!name) {
            await this.showInlineError('이름을 입력하세요.');
            return;
        }

        const oldPath = this.inlineRenamePath;
        const oldSelectedPath = this.selectedPath;
        const previousMode = this.mode;
        const renameOrigin = this.inlineRenameOrigin;
        this.renaming = true;
        this.inlineError = '';
        await this.service.render();

        const res = await wiz.call('save', { mode: 'rename', path: this.scopedPath(oldPath), name: name });
        this.renaming = false;

        if (res.code !== 200) {
            await this.showInlineError(res.data?.message || '이름 변경에 실패했습니다.');
            return;
        }

        const renamed = this.toViewItem(res.data);
        if (this.isSameOrChildPath(this.selectedPath, oldPath)) {
            this.selectedPath = this.replacePathPrefix(this.selectedPath, oldPath, renamed.path);
        }
        if (this.isSameOrChildPath(this.activeFolderPath, oldPath)) {
            this.activeFolderPath = this.replacePathPrefix(this.activeFolderPath, oldPath, renamed.path);
        }
        if (this.expanded[oldPath]) {
            this.expanded[renamed.path] = true;
            delete this.expanded[oldPath];
        }

        this.cancelRename(false);
        this.expandParents(renamed.path);
        await this.loadTree();

        if (renamed.type === 'file' && oldSelectedPath === oldPath) {
            await this.selectDoc(renamed);
            if (renameOrigin === 'title' && previousMode === 'edit') {
                this.mode = 'edit';
            }
        }

        await this.showMessage('이름을 변경했습니다.');
    }

    public async deleteItem(item: any, event?: Event) {
        this.stopEvent(event);
        if (!item || this.deleting) return;

        const message = item.type === 'folder'
            ? `'${item.title}' 폴더와 하위 문서를 삭제할까요?`
            : `'${item.title}' 문서를 삭제할까요?`;
        const confirmed = await this.service.alert.error(message, '취소', '삭제');
        if (!confirmed) return;

        this.cancelCreate(false);
        this.cancelRename(false);
        this.deleting = true;
        this.message = '';
        await this.service.render();

        const deletedPath = this.normalizePath(item.path);
        const res = await wiz.call('save', { mode: 'delete', path: this.scopedPath(deletedPath) });
        this.deleting = false;

        if (res.code !== 200) {
            await this.showMessage(res.data?.message || '삭제에 실패했습니다.');
            return;
        }

        if (this.isSameOrChildPath(this.selectedPath, deletedPath)) {
            this.selectedDoc = null;
            this.selectedPath = '';
            this.selectedTitle = '';
            this.docContent = '';
            this.htmlContent = '';
            this.headings = [];
            this.mode = 'preview';
        }
        if (this.isSameOrChildPath(this.activeFolderPath, deletedPath)) {
            this.activeFolderPath = this.parentPath(deletedPath);
        }
        this.clearExpandedPath(deletedPath);

        await this.loadTree();
        await this.showMessage(item.type === 'folder' ? '폴더를 삭제했습니다.' : '문서를 삭제했습니다.');
    }

    public async startFileDrag(item: any, event: DragEvent) {
        if (!item || item.type !== 'file') return;
        this.draggingPath = item.path;
        this.dragOverPath = '';
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', item.path);
        }
        event.stopPropagation();
        await this.service.render();
    }

    public async endFileDrag(event?: DragEvent) {
        if (event) event.stopPropagation();
        this.clearDragState();
        await this.service.render();
    }

    public canDropOnFolder(item: any): boolean {
        if (!item || item.type !== 'folder' || !this.draggingPath || this.moving) return false;
        return this.normalizePath(this.parentPath(this.draggingPath)) !== this.normalizePath(item.path);
    }

    public canDropOnRoot(): boolean {
        if (!this.draggingPath || this.moving) return false;
        return this.normalizePath(this.parentPath(this.draggingPath)) !== '';
    }

    public async handleRootDragOver(event: DragEvent) {
        if (!this.canDropOnRoot()) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.dragOverPath !== this.rootDropPath) {
            this.dragOverPath = this.rootDropPath;
            await this.service.render();
        }
    }

    public async handleRootDragLeave(event: DragEvent) {
        event.stopPropagation();
        const current = event.currentTarget as HTMLElement;
        const related = event.relatedTarget as Node;
        if (current && related && current.contains(related)) return;
        if (this.dragOverPath === this.rootDropPath) {
            this.dragOverPath = '';
            await this.service.render();
        }
    }

    public async dropFileOnRoot(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.canDropOnRoot()) {
            this.clearDragState();
            await this.service.render();
            return;
        }

        const sourcePath = this.normalizePath(this.draggingPath);
        await this.moveFileToParent(sourcePath, '');
    }

    public async handleFolderDragOver(item: any, event: DragEvent) {
        if (!this.canDropOnFolder(item)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.dragOverPath !== item.path) {
            this.dragOverPath = item.path;
            await this.service.render();
        }
    }

    public async handleFolderDragLeave(item: any, event: DragEvent) {
        event.stopPropagation();
        const current = event.currentTarget as HTMLElement;
        const related = event.relatedTarget as Node;
        if (current && related && current.contains(related)) return;
        if (this.dragOverPath === item.path) {
            this.dragOverPath = '';
            await this.service.render();
        }
    }

    public async dropFileOnFolder(item: any, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.canDropOnFolder(item)) {
            this.clearDragState();
            await this.service.render();
            return;
        }

        const sourcePath = this.normalizePath(this.draggingPath);
        const targetParent = this.normalizePath(item.path);
        await this.moveFileToParent(sourcePath, targetParent);
    }

    private async moveFileToParent(sourcePath: string, targetParent: string) {
        targetParent = this.normalizePath(targetParent);
        this.clearDragState();
        this.cancelCreate(false);
        this.cancelRename(false);
        this.moving = true;
        this.message = '';
        await this.service.render();

        const res = await wiz.call('save', { mode: 'move', path: this.scopedPath(sourcePath), parent: this.scopedPath(targetParent) });
        this.moving = false;

        if (res.code !== 200) {
            await this.showMessage(res.data?.message || '문서 이동에 실패했습니다.');
            return;
        }

        const moved = this.toViewItem(res.data);
        if (targetParent) this.expanded[targetParent] = true;
        this.expandParents(moved.path);
        if (this.sameText(this.selectedPath, sourcePath)) {
            this.selectedDoc = moved;
            this.selectedPath = moved.path;
            this.selectedTitle = moved.title;
            this.activeFolderPath = this.parentPath(moved.path);
        }

        await this.loadTree();
        await this.showMessage(targetParent ? '문서를 이동했습니다.' : '문서를 처음 경로로 이동했습니다.');
    }

    public async selectDoc(item: any) {
        if (!item || item.type !== 'file' || this.loading) return;
        this.selectedDoc = item;
        this.selectedPath = item.path;
        this.selectedTitle = item.title;
        this.activeFolderPath = this.parentPath(item.path);
        this.loading = true;
        this.message = '';
        await this.service.render();

        const res = await wiz.call('load', { path: this.scopedPath(item.path) });
        if (res.code === 200) {
            const loaded = this.toViewItem({ title: res.data.title, path: res.data.path, type: 'file' });
            this.selectedPath = loaded.path;
            this.selectedTitle = loaded.title;
            this.selectedDoc = loaded;
            this.activeFolderPath = this.parentPath(loaded.path);
            this.docContent = res.data.content || '';
            this.docMode = res.data.mode || 'markdown';
            this.renderContent(this.docContent, this.docMode);
            this.mode = 'preview';
        } else {
            this.docContent = '';
            this.docMode = 'markdown';
            this.htmlContent = '';
            this.headings = [];
            await this.showMessage(res.data?.message || '문서를 불러올 수 없습니다.');
        }

        this.loading = false;
        await this.service.render();
        this.scheduleContentHighlight();
    }

    public async saveDoc() {
        if (!this.selectedPath || this.saving) return;
        this.saving = true;
        this.message = '';
        await this.service.render();

        const res = await wiz.call('save', { path: this.scopedPath(this.selectedPath), content: this.docContent || '' });
        this.saving = false;

        if (res.code !== 200) {
            await this.showMessage(res.data?.message || '저장에 실패했습니다.');
            return;
        }

        this.docMode = this.selectedPath.endsWith('.txt') ? 'text' : 'markdown';
        this.renderContent(this.docContent || '', this.docMode);
        this.mode = 'preview';
        await this.showMessage('저장했습니다.');
        this.scheduleContentHighlight();
    }

    public async toggleFolder(item: any) {
        this.activeFolderPath = item.path;
        this.expanded[item.path] = !this.expanded[item.path];
        await this.service.render();
    }

    public async setMode(mode: string) {
        this.mode = mode;
        if (mode === 'preview') {
            this.cancelRename(false);
            this.docMode = this.selectedPath.endsWith('.txt') ? 'text' : 'markdown';
            this.renderContent(this.docContent || '', this.docMode);
            await this.service.render();
            this.scheduleContentHighlight();
            return;
        }
        if (mode === 'edit' && this.selectedDoc) {
            await this.startRename(this.selectedDoc, undefined, 'title');
            return;
        }
        await this.service.render();
    }

    public async scrollToHeading(id: string) {
        this.activeHeadingId = id;
        if (this.mode !== 'preview') {
            this.cancelRename(false);
            this.mode = 'preview';
            this.docMode = this.selectedPath.endsWith('.txt') ? 'text' : 'markdown';
            this.renderContent(this.docContent || '', this.docMode);
            await this.service.render();
            this.scheduleContentHighlight();
        } else {
            await this.service.render();
        }

        window.setTimeout(() => this.scrollPreviewTo(id));
    }

    public isCreatingIn(path: string): boolean {
        return !!this.inlineCreateType && this.normalizePath(this.inlineCreateParent) === this.normalizePath(path);
    }

    public isRenaming(item: any): boolean {
        return this.inlineRenameOrigin === 'tree' && !!item && !!this.inlineRenamePath && this.normalizePath(item.path) === this.normalizePath(this.inlineRenamePath);
    }

    public isSelectedRenaming(): boolean {
        return this.inlineRenameOrigin === 'title' && !!this.selectedDoc && !!this.inlineRenamePath && this.normalizePath(this.selectedDoc.path) === this.normalizePath(this.inlineRenamePath);
    }

    public async handleRowCreate(type: string, item: any, event?: Event) {
        await this.startCreate(type, item?.path || '', event);
    }

    private async loadCommunityScope() {
        const session = this.service.auth?.session || {};
        if (session.role === 'admin') return;

        const communityId = session.community_id || '';
        if (!communityId) return;

        try {
            const form = new FormData();
            form.append('id', communityId);
            const response = await fetch('/wiz/api/portal.gsdcadmin.community.info/load', {
                method: 'POST',
                body: form,
                cache: 'no-store'
            });
            const result = await response.json();
            const name = result?.data?.community?.name || '';
            if (result.code === 200 && name) {
                this.communityName = String(name);
            }
        } catch (error) {}
    }

    private applyCommunityScope(items: any[]): any[] {
        const docs = items || [];
        this.scopePrefix = '';
        if (!this.communityName) return docs;

        const root = docs.find((item: any) => item?.type === 'folder' && this.sameText(item.title, this.communityName));
        if (!root) return docs;

        this.scopePrefix = this.normalizePath(root.path || root.title);
        return (root.children || []).map((item: any) => this.toViewItem(item));
    }

    private toViewItem(item: any): any {
        const viewItem = {
            ...item,
            path: this.unscopedPath(item?.path || '')
        };
        if (item?.children) {
            viewItem.children = item.children.map((child: any) => this.toViewItem(child));
        }
        return viewItem;
    }

    private currentFolderPath(): string {
        return this.normalizePath(this.activeFolderPath || '');
    }

    private parentPath(path: string): string {
        const normalized = this.normalizePath(path);
        const index = normalized.lastIndexOf('/');
        if (index < 0) return '';
        return normalized.slice(0, index);
    }

    private scopedPath(path: string): string {
        const normalized = this.normalizePath(path);
        const prefix = this.normalizePath(this.scopePrefix);
        if (!prefix) return normalized;
        if (!normalized) return prefix;
        if (this.sameText(normalized, prefix)) return normalized;
        if (this.sameText(normalized.slice(0, prefix.length), prefix) && normalized.charAt(prefix.length) === '/') return normalized;
        return prefix + '/' + normalized;
    }

    private unscopedPath(path: string): string {
        const normalized = this.normalizePath(path);
        const prefix = this.normalizePath(this.scopePrefix);
        if (!prefix) return normalized;
        if (this.sameText(normalized, prefix)) return '';
        if (this.sameText(normalized.slice(0, prefix.length), prefix) && normalized.charAt(prefix.length) === '/') {
            return normalized.slice(prefix.length + 1);
        }
        return normalized;
    }

    private normalizePath(path: string): string {
        return String(path || '').normalize('NFC').replace(/\\/g, '/').replace(/^\/+|\/+$/g, '');
    }

    private sameText(left: string, right: string): boolean {
        return String(left || '').normalize('NFC').toLowerCase() === String(right || '').normalize('NFC').toLowerCase();
    }

    private normalizeSearch(value: string): string {
        return String(value || '').normalize('NFC').toLowerCase().trim();
    }

    private applyTreeFilter() {
        const keyword = this.normalizeSearch(this.treeSearch);
        if (!keyword) {
            this.filteredDocs = this.withTitleParts(this.docs || [], keyword);
            return;
        }

        this.filteredDocs = (this.docs || [])
            .map((item: any) => this.filterTreeItem(item, keyword))
            .filter((item: any) => !!item);
    }

    private filterTreeItem(item: any, keyword: string): any {
        const title = this.normalizeSearch(item?.title || '');
        const path = this.normalizeSearch(item?.path || '');
        const children = (item?.children || [])
            .map((child: any) => this.filterTreeItem(child, keyword))
            .filter((child: any) => !!child);

        if (title.indexOf(keyword) >= 0 || path.indexOf(keyword) >= 0 || children.length > 0) {
            return { ...item, children: children, titleParts: this.createTitleParts(item.title, keyword) };
        }

        return null;
    }

    private withTitleParts(items: any[], keyword: string): any[] {
        return (items || []).map((item: any) => ({
            ...item,
            titleParts: this.createTitleParts(item.title, keyword),
            children: this.withTitleParts(item.children || [], keyword)
        }));
    }

    private createTitleParts(title: string, keyword: string): any[] {
        const text = String(title || '');
        if (!keyword) return [{ text: text, match: false }];

        const normalized = text.normalize('NFC').toLowerCase();
        const index = normalized.indexOf(keyword);
        if (index < 0) return [{ text: text, match: false }];

        const end = index + keyword.length;
        return [
            { text: text.slice(0, index), match: false },
            { text: text.slice(index, end), match: true },
            { text: text.slice(end), match: false }
        ].filter((part: any) => part.text.length > 0);
    }

    private isSameOrChildPath(path: string, parent: string): boolean {
        const target = this.normalizePath(path);
        const base = this.normalizePath(parent);
        if (!base) return true;
        return this.sameText(target, base) || (this.sameText(target.slice(0, base.length), base) && target.charAt(base.length) === '/');
    }

    private replacePathPrefix(path: string, oldPrefix: string, newPrefix: string): string {
        const target = this.normalizePath(path);
        const oldPath = this.normalizePath(oldPrefix);
        const nextPath = this.normalizePath(newPrefix);
        if (this.sameText(target, oldPath)) return nextPath;
        if (this.isSameOrChildPath(target, oldPath)) return nextPath + target.slice(oldPath.length);
        return target;
    }

    private clearExpandedPath(path: string) {
        const target = this.normalizePath(path);
        for (const key of Object.keys(this.expanded)) {
            if (this.isSameOrChildPath(key, target)) {
                delete this.expanded[key];
            }
        }
    }

    private clearDragState() {
        this.draggingPath = '';
        this.dragOverPath = '';
    }

    private async showInlineError(message: string) {
        this.inlineError = message;
        if (this.inlineErrorTimer) window.clearTimeout(this.inlineErrorTimer);
        await this.service.render();
        this.inlineErrorTimer = window.setTimeout(async () => {
            if (this.inlineError === message) {
                this.inlineError = '';
                await this.service.render();
            }
        }, 3000);
    }

    private async showMessage(message: string) {
        this.message = message;
        if (this.messageTimer) window.clearTimeout(this.messageTimer);
        await this.service.render();
        this.messageTimer = window.setTimeout(async () => {
            if (this.message === message) {
                this.message = '';
                await this.service.render();
            }
        }, 3000);
    }

    private focusInlineInput() {
        window.setTimeout(() => {
            const input = document.querySelector('.tree-inline-input') as HTMLInputElement;
            if (input) {
                input.focus();
                input.select();
            }
        });
    }

    private stopEvent(event?: Event) {
        if (!event) return;
        event.preventDefault();
        event.stopPropagation();
    }

    private findByPath(items: any[], path: string): any {
        const target = this.normalizePath(path);
        for (const item of items || []) {
            if (this.sameText(item.path, target)) return item;
            const found = this.findByPath(item.children || [], target);
            if (found) return found;
        }
        return null;
    }

    private renderContent(content: string, mode: string) {
        let html = mode === 'markdown' ? this.converter.makeHtml(content) : '<pre>' + this.escapeHtml(content) + '</pre>';
        const container = document.createElement('div');
        container.innerHTML = html;

        const headings: any[] = [];
        const nodes = container.querySelectorAll('h1, h2, h3');
        nodes.forEach((node: any, index: number) => {
            const text = (node.textContent || '').trim();
            if (!text) return;
            const id = 'admin-manual-heading-' + index;
            node.setAttribute('id', id);
            headings.push({ id: id, text: text, level: Number(String(node.tagName).replace('H', '')), index: index });
        });

        this.highlightContent(container, this.normalizeSearch(this.treeSearch));
        this.htmlContent = container.innerHTML;
        this.headings = headings;
        if (!this.headings.some((heading: any) => heading.id === this.activeHeadingId)) {
            this.activeHeadingId = '';
        }
    }

    private highlightContent(container: HTMLElement, keyword: string) {
        if (!keyword) return;

        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
        const textNodes: Text[] = [];
        let node = walker.nextNode();
        while (node) {
            if (!this.isHighlightExcluded(node)) textNodes.push(node as Text);
            node = walker.nextNode();
        }

        for (const textNode of textNodes) {
            this.highlightTextNode(textNode, keyword);
        }
    }

    private scheduleContentHighlight() {
        window.setTimeout(() => this.highlightRenderedContent());
    }

    private highlightRenderedContent() {
        const element = this.markdownBody?.nativeElement;
        if (!element) return;
        this.highlightContent(element, this.normalizeSearch(this.treeSearch));
    }

    private isHighlightExcluded(node: Node): boolean {
        const parent = node.parentElement;
        if (!parent) return true;
        return !!parent.closest('script, style, textarea, input, select, option, mark.manual-content-match');
    }

    private highlightTextNode(textNode: Text, keyword: string) {
        const text = textNode.nodeValue || '';
        const normalized = text.normalize('NFC').toLowerCase();
        let index = normalized.indexOf(keyword);
        if (index < 0) return;

        const fragment = document.createDocumentFragment();
        let cursor = 0;
        while (index >= 0) {
            if (index > cursor) {
                fragment.appendChild(document.createTextNode(text.slice(cursor, index)));
            }

            const end = index + keyword.length;
            const mark = document.createElement('mark');
            mark.className = 'manual-content-match';
            mark.textContent = text.slice(index, end);
            fragment.appendChild(mark);

            cursor = end;
            index = normalized.indexOf(keyword, cursor);
        }

        if (cursor < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(cursor)));
        }

        textNode.parentNode?.replaceChild(fragment, textNode);
    }

    private scrollPreviewTo(id: string) {
        const container = document.querySelector('.preview-area') as HTMLElement;
        const heading = this.headings.find((item: any) => item.id === id);
        const nodes = container ? Array.from(container.querySelectorAll('.markdown-body h1, .markdown-body h2, .markdown-body h3')) : [];
        const element = (heading && nodes[heading.index] ? nodes[heading.index] : document.getElementById(id)) as HTMLElement;
        if (!element) return;

        if (!container) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const top = container.scrollTop + (elementRect.top - containerRect.top) - 14;
        container.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    private escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(text || ''));
        return div.innerHTML;
    }

    private findFirstFile(items: any[]): any {
        for (const item of items || []) {
            if (item.type === 'file') return item;
            const found = this.findFirstFile(item.children || []);
            if (found) return found;
        }
        return null;
    }

    private expandParents(path: string) {
        const parts = (path || '').split('/');
        let current = '';
        for (let i = 0; i < parts.length - 1; i++) {
            current = current ? current + '/' + parts[i] : parts[i];
            this.expanded[current] = true;
        }
    }
}

export default PortalGsdcadminManualListComponent;